import {header} from "./modules/header";
import {iacoModal} from "./modules/modal";
import {initLabel} from "./modules/floatlabel";
import preloader from "./modules/preloader";
import smoothScrollScripts from "./modules/locomotiveScroll";
import Dropdowns from './components/dropdowns';
import Filtration from './components/filtration';
import GForms from './components/gforms';
import Footer from "./components/contact-form";

import LocomotiveScroll from "locomotive-scroll";

window.addEventListener("load", function () {
  const smoothScroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
  })
  setTimeout(preloader, 3500);
  header(smoothScroll).init()
  iacoModal(smoothScroll)
  initLabel()
  smoothScrollScripts.init(smoothScroll)
  Dropdowns.init();
  Filtration.init(smoothScroll);
  GForms.init(smoothScroll);
  Footer.init();
})
